module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "今日打卡分配数统计",
      "width": "350"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Table', {
    ref: "table",
    attrs: {
      "height": "300",
      "columns": _vm.title,
      "data": _vm.tableData,
      "stripe": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-720e0f8e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/TodayPunchStatisticsModal.vue
// module id = 1883
// module chunks = 8